/* eslint-disable max-lines */
/* eslint-disable max-len */
import React from 'react';

interface INotFoundSVG {
  clasName?: string;
  [other: string]: string | undefined;
}
const NotFoundSVG: React.FC<INotFoundSVG> = props => {
  return (
    <svg viewBox="0 0 1821.333 1024" {...props}>
      <defs>
        <clipPath id="prefix__c" clipPathUnits="userSpaceOnUse">
          <path d="M0 0h1366v542.893H0z" />
        </clipPath>
        <clipPath id="prefix__d" clipPathUnits="userSpaceOnUse">
          <path d="M-156.06 450.64h1732.67v-992.045H-156.06z" />
        </clipPath>
        <clipPath id="prefix__e" clipPathUnits="userSpaceOnUse">
          <path d="M-173.299 505.234H1559.37V-495.431H-173.299z" />
        </clipPath>
        <clipPath id="prefix__f" clipPathUnits="userSpaceOnUse">
          <path d="M-82.788 260.034h238.991v-87.021h-238.99z" />
        </clipPath>
        <clipPath id="prefix__g" clipPathUnits="userSpaceOnUse">
          <path d="M-81.351 178.384s135.05-17.24 205.449 10.057c62.694 24.311 21.55 80.455-21.55 70.401C45.167 245.451-82.788 220.05-82.788 220.05z" />
        </clipPath>
        <clipPath id="prefix__j" clipPathUnits="userSpaceOnUse">
          <path d="M-46.695 491.106H29.5v-79.702h-76.194z" />
        </clipPath>
        <clipPath id="prefix__k" clipPathUnits="userSpaceOnUse">
          <path d="M-41.602 434.598s11.253-19.338 46.27-22.749c52.021-5.07 2.932 34 22.687 79.257-30.41-34.899-74.05-33.1-74.05-33.1z" />
        </clipPath>
        <clipPath id="prefix__n" clipPathUnits="userSpaceOnUse">
          <path d="M601.95 251.808h144.73v-33.016H601.95z" />
        </clipPath>
        <clipPath id="prefix__o" clipPathUnits="userSpaceOnUse">
          <path d="M687.123 244.122h5.753v-8.846h-5.753z" />
        </clipPath>
        <clipPath id="prefix__p" clipPathUnits="userSpaceOnUse">
          <path d="M694.799 250.181h13.235v-6.907h-13.235z" />
        </clipPath>
        <clipPath id="prefix__q" clipPathUnits="userSpaceOnUse">
          <path d="M690.922 302.483h17.643v-9.782h-17.643z" />
        </clipPath>
        <clipPath id="prefix__r" clipPathUnits="userSpaceOnUse">
          <path d="M620.297 240.052h5.753v-8.902h-5.753z" />
        </clipPath>
        <clipPath id="prefix__s" clipPathUnits="userSpaceOnUse">
          <path d="M628.115 245.309h12.782v-5.24h-12.782z" />
        </clipPath>
        <clipPath id="prefix__t" clipPathUnits="userSpaceOnUse">
          <path d="M635.765 296.616h12.012v-12.355h-12.012z" />
        </clipPath>
        <clipPath id="prefix__u" clipPathUnits="userSpaceOnUse">
          <path d="M650.723 409.846h5.555v-2.284h-5.555z" />
        </clipPath>
        <clipPath id="prefix__v" clipPathUnits="userSpaceOnUse">
          <path d="M640.369 385.206h16.976v-11.647h-16.976z" />
        </clipPath>
        <clipPath id="prefix__w" clipPathUnits="userSpaceOnUse">
          <path d="M713.129 237.451h5.752v-8.847h-5.752z" />
        </clipPath>
        <clipPath id="prefix__x" clipPathUnits="userSpaceOnUse">
          <path d="M617.609 384.607h2.177v-5.767h-2.177z" />
        </clipPath>
        <clipPath id="prefix__y" clipPathUnits="userSpaceOnUse">
          <path d="M616.796 392.408h.878v-4.47h-.878z" />
        </clipPath>
        <clipPath id="prefix__z" clipPathUnits="userSpaceOnUse">
          <path d="M621.731 365.908h3.078v-3.239h-3.078z" />
        </clipPath>
        <clipPath id="prefix__A" clipPathUnits="userSpaceOnUse">
          <path d="M714.936 318.463h5.204v-13.846h-5.204z" />
        </clipPath>
        <clipPath id="prefix__B" clipPathUnits="userSpaceOnUse">
          <path d="M622.891 389.747h5.909v-5.39h-5.909z" />
        </clipPath>
        <clipPath id="prefix__C" clipPathUnits="userSpaceOnUse">
          <path d="M645.173 236.996h5.754v-8.846h-5.754z" />
        </clipPath>
        <clipPath id="prefix__D" clipPathUnits="userSpaceOnUse">
          <path d="M718.014 244.749h12.117v-5.978h-12.117z" />
        </clipPath>
        <clipPath id="prefix__E" clipPathUnits="userSpaceOnUse">
          <path d="M651.449 243.381h14.431v-6.137h-14.431z" />
        </clipPath>
        <clipPath id="prefix__F" clipPathUnits="userSpaceOnUse">
          <path d="M644.947 307.536h23.76v-20.082h-23.76z" />
        </clipPath>
        <linearGradient
          id="prefix__a"
          spreadMethod="pad"
          gradientTransform="matrix(238.99117 0 0 87.02079 -82.788 216.524)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopOpacity={0} stopColor="#fff" />
          <stop offset={1} stopOpacity={0.322} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__i"
          spreadMethod="pad"
          gradientTransform="matrix(238.99117 0 0 87.02079 -82.788 216.524)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#ff8b3d" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          spreadMethod="pad"
          gradientTransform="matrix(76.19342 0 0 79.70207 -46.695 451.255)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopOpacity={0} stopColor="#fff" />
          <stop offset={1} stopOpacity={0.322} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="prefix__m"
          spreadMethod="pad"
          gradientTransform="matrix(76.19342 0 0 79.70207 -46.695 451.255)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#ff8b3d" />
        </linearGradient>
        <mask
          id="prefix__h"
          height={1}
          width={1}
          y={0}
          x={0}
          maskUnits="userSpaceOnUse"
        >
          <path d="M-32768 32767h65535v-65535h-65535z" fill="url(#prefix__a)" />
        </mask>
        <mask
          id="prefix__l"
          height={1}
          width={1}
          y={0}
          x={0}
          maskUnits="userSpaceOnUse"
        >
          <path d="M-32768 32767h65535v-65535h-65535z" fill="url(#prefix__b)" />
        </mask>
      </defs>
      <g
        clipPath="url(#prefix__c)"
        transform="matrix(1.33333 0 0 -1.33333 0 1024)"
      >
        <g clipPath="url(#prefix__d)" opacity={0.2}>
          <path
            d="M-102.9 427.172s394.613-68 476.026 4.79c154.206-45.017 281.593-39.269 363.965-1.917 65.131-46.932 277.762-97.934 382.643-13.168 93.385-116.373 456.871 33.762 456.871 33.762l-242.8-992.044-1489.865 23.706z"
            className="fill-svg-primary-darker-1x"
          />
        </g>
        <g clipPath="url(#prefix__e)" opacity={0.2}>
          <path
            d="M-120.143 481.768s66.568-63.693 147.981 9.1c137.925-77.582 507.636 53.636 692.013-6.225 184.377-59.861 459.505-88.6 530.622 1.915 93.387-116.372 308.892 18.677 308.892 18.677L1404.201-495.43l-1577.5 32.326z"
            className="fill-svg-primary-darker-1x"
          />
        </g>
        <path
          d="M-71.295 296.912s185.336-7.183 249.987 99.133c175.277-137.925 350.024-56.227 511.467-8.62 168.094 49.566 537.326-99.134 601.98 31.606 93.384-116.372 303.143-20.113 303.143-20.113L1343.86-604.619l-1481.243 35.2z"
          className="fill-svg-primary-lighter-3x"
        />
        <g clipPath="url(#prefix__f)">
          <g clipPath="url(#prefix__g)" opacity={0.2}>
            <g mask="url(#prefix__h)">
              <path
                d="M-81.351 178.384s135.05-17.24 205.449 10.057c62.694 24.311 21.55 80.455-21.55 70.401C45.167 245.451-82.788 220.05-82.788 220.05z"
                fill="url(#prefix__i)"
              />
            </g>
          </g>
        </g>
        <g clipPath="url(#prefix__j)">
          <g clipPath="url(#prefix__k)" opacity={0.32}>
            <g mask="url(#prefix__l)">
              <path
                d="M-41.602 434.598s11.253-19.338 46.27-22.749c52.021-5.07 2.932 34 22.687 79.257-30.41-34.899-74.05-33.1-74.05-33.1z"
                fill="url(#prefix__m)"
              />
            </g>
          </g>
        </g>
        <path
          d="M-75.604 181.259s231.2 123.556 356.3 123.556c133.614 0 522.961-110.626 679.561-61.06 160.471 50.79 362.052 38.792 525.834-40.945 163.783-79.738 94.822-77.582 94.822-77.582l-238.493-514.34-1509.25 33.76z"
          className="fill-svg-primary-lighter-2x"
        />
        <path
          d="M-40.406 245.191s66.808-73.27 189.646-96.977C272.078 124.51 568.883 251.97 646.1 258.361c144.627 11.971 212.154-77.823 375.937-157.558 163.783-79.735 491.354 51.721 491.354 51.721l28.014-271.539-1661.548-19.395z"
          className="fill-svg-primary-lighter-1x"
        />
        <g clipPath="url(#prefix__n)" opacity={0.12}>
          <path
            d="M674.315 251.809c39.966 0 72.366-7.391 72.366-16.508 0-9.117-32.4-16.508-72.366-16.508s-72.365 7.39-72.365 16.508c0 9.117 32.399 16.508 72.365 16.508"
            className="fill-svg-primary-darker-4x"
          />
        </g>
        <path
          d="M697.042 249.548s-15.49-5.654-16.735-9.612c-1.245-3.958 5.881-5.201 7.123-4.635 1.243.564 2.6-1.357 8.707-.905 6.107.452 12.325 4.523 11.532 14.926-2.713-.794-10.627.226-10.627.226"
          className="fill-svg-primary"
        />
        <g clipPath="url(#prefix__o)" opacity={0.35}>
          <path
            d="M687.144 235.275c-.35 4.066 3.67 7.242 3.841 7.376l1.89 1.47-1.486-1.878c-4.035-5.1-3.189-6.882-3.189-6.882z"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <path
          d="M702.314 249.561l.028-.6a25.846 25.846 0 00-.099-3.835c1.342 1.314 3.2 3.385 3.217 3.411l.207.23 2.6-2.662-1.12 4.08.584-.3c.011-.007.777-.4 1.843-.875a10.851 10.851 0 00-2.3 5.13c-.628 3.676 4.87 14.353 8.651 19.11 2.101 2.844 3.028 5.083 2.743 6.65a2.543 2.543 0 01-1.2 1.748l-.056.047c-.282.308-.614.644-.979 1.02a30.039 30.039 0 00-9.27 18.927c-.392 3.216-2.457 4-4.12 4.1-4.219.253-10.308-3.7-11.588-8.962-.057-4.891 12.074-17.205 15.41-18.347l.181-.061.014-.193c.78-12.111-5.337-22.237-6.036-23.351a10.676 10.676 0 00-6.416-5.113c-.2-.07-.4-.138-.59-.208a20.65 20.65 0 013.845.454l.415.1-.063-.42a16.69 16.69 0 00-.886-3.326 19.228 19.228 0 014.54 2.855z"
          className="fill-svg-primary"
        />
        <g clipPath="url(#prefix__p)" opacity={0.35}>
          <path
            d="M707.695 246.683l-2.032 2.08-.206-.23c-.022-.025-1.876-2.1-3.218-3.412a26 26 0 01.1 3.836l-.029.6-.452-.4a19.184 19.184 0 00-4.54-2.854c.41 1.075.706 2.19.887 3.326l.062.42-.415-.1c-.01 0-.558-.127-1.377-.246l-1.676-.755c.927.056 1.85.173 2.763.349a14.932 14.932 0 00-1.05-3.4l-.307-.641.666.243a18.751 18.751 0 014.907 2.837 14.733 14.733 0 00-.3-3.97l-.417-1.091.877.77c1.1.965 3.09 3.149 3.737 3.867l1.932-1.975zM708.034 249.727l-.307.154-.586.3.67-2.442z"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g clipPath="url(#prefix__q)" opacity={0.35}>
          <path
            d="M690.922 293.638s2.482-2.685 10.1 1.034c7.363 3.59 7.544 7.184 7.544 7.184l-6.557.628z"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <path
          d="M630.669 245.929s-15.942-6.106-17.187-10.064c-1.245-3.958 5.88-5.201 7.125-4.635 1.245.565 1.243-2.262 7.349-1.81 6.106.45 13.682 5.428 12.89 15.829-2.715-.791-10.177.68-10.177.68"
          className="fill-svg-primary"
        />
        <path
          d="M634.776 244.218l.028-.42a6.908 6.908 0 00-.246-2.173c1.575.822 3.811 1.7 3.921 1.746l.1.037 4.153-1.381-1.49 2.783a10.327 10.327 0 012.018-1.071 4.64 4.64 0 00-2.36 4.225c0 1.173-.014 2.458-.027 3.739-.024 2.5-.05 5.089.026 6.678l.015.3.3-.026c.073-.011.318.114.685.624 1.2 1.663 2.858 6.44 1.625 9.26l-.04.094.026.1c1.151 4.287 4.2 20.789 4.54 22.613l-12.955 4.584c.417-3.668 2.691-23.693 3.1-25.515l.026-.12-.068-.1c-1.248-1.873-3.119-7.874-.923-10.508l.1-.125-.05-.153a4.37 4.37 0 01.04-1.034 9.132 9.132 0 00-.743-5.461c-1.292-2.286-4.744-6.544-7.81-7.591a7.588 7.588 0 013.426-.126l.523.114-.19-.5a4.998 4.998 0 00-1.244-1.71c1.064.22 2.106.537 3.113.945z"
          className="fill-svg-primary"
        />
        <path
          d="M640.846 245.249c-2.649 3.175-10.178.68-10.178.68s-15.942-6.107-17.187-10.065c-1.169-3.722 5.063-5.043 6.84-4.716v.055c-.349 4.068 3.67 7.244 3.841 7.378l1.891 1.471-1.485-1.878c-3.27-4.133-3.336-6.318-3.242-7 .821-.471 1.863-2.112 6.633-1.758 6.103.457 13.68 5.433 12.887 15.833"
          className="fill-svg-primary"
        />
        <g clipPath="url(#prefix__r)" opacity={0.35}>
          <path
            d="M624.565 238.175l1.485 1.878-1.89-1.471c-.172-.134-4.19-3.31-3.842-7.378v-.054c.098.016.193.043.285.08a.725.725 0 00.716-.05c-.088.678-.025 2.863 3.246 6.995"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g clipPath="url(#prefix__s)" opacity={0.35}>
          <path
            d="M640.89 242.638l-2.315.77-.1-.037c-.11-.044-2.346-.924-3.92-1.745a6.84 6.84 0 01.245 2.173l-.028.419-.382-.176a18.083 18.083 0 00-3.113-.945 5.017 5.017 0 011.247 1.712l.191.5-.523-.114a7.781 7.781 0 00-3.293.09l-.784-.291a7.08 7.08 0 013.613-.457 4.965 4.965 0 00-1.87-1.743l-1.65-.88 1.836.34c1.426.244 2.827.613 4.188 1.1a4.766 4.766 0 00-.527-2.246l-.646-1.04 1.043.642a38.37 38.37 0 004.494 2.085l2.3-.767c.002.239.001.445-.006.61"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g clipPath="url(#prefix__t)" opacity={0.35}>
          <path
            d="M638.682 296.616c-2.9 0-3.025-3.668-2.878-6.908.01-.199.125-.952.125-1.223a12.01 12.01 0 012.974-2.552c-.32 1.335-1.487 4.16-1.724 4.97-.163.742-.253 1.5-.27 2.26l-.036.006c.457-2.942 5.14-8.317 5.781-8.907.373.44.7.768 1.15 1.352.427.974.6 2.041.5 3.101h-.006a4.993 4.993 0 012.464-4.232c.094.401.778 4.146.784 4.18.088.516.231 1.2.231 1.208-.004 3.866-5.177 6.745-9.095 6.745"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <path
          d="M656.161 408.862c0-1.342-6.194-4.843-10.156-6.767l-5.763.97-3.253-3.083c-.347-.03-.76-.1-1.23-.182-1.7-.286-4.02-.679-5.232.453a4.527 4.527 0 00-1.25 3.2 4.99 4.99 0 001.37 3.618c.992.991 3.61 1.571 6.621 1.571 2.69.026 5.362-.45 7.877-1.408 2.144-.878 3.8-1.035 4.931-.472.525.243.927.69 1.113 1.237l.03.116-.062.1c-.079.136-1.676 2.8-4.044 3.567a8.05 8.05 0 004.411-1.57l.316-.24.132.374a6.853 6.853 0 01.226 3.668 10.6 10.6 0 001.6-2.875l.151-.437.327.327c.035.035 3.1 3.075 5.658 3.822-1.767-1.543-3.773-4.117-3.773-5.989"
          className="fill-svg-primary"
        />
        <g clipPath="url(#prefix__u)" opacity={0.35}>
          <path
            d="M650.723 408.883a3.617 3.617 0 001.476-.26 4.115 4.115 0 004.08 1.058c-.069-.363-.119-.564-.119-.564l-3.686-1.555-1.368.762z"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <path
          d="M632.366 405.921c1.75 1.05 6.906 2.464 10.4-1.382-.696-1.31-12.434-1.897-10.4 1.382"
          className="fill-svg-primary-darker-2x"
        />
        <path
          d="M739.238 276.284c-1.946-1.947-9.884-24.615-9.884-29.528a10.153 10.153 0 011.667-5.3c.248-.419.475-.85.676-1.293a6.749 6.749 0 00-3.184 2.175l-.299.366-.195-.428a6.629 6.629 0 01-.417-1.86 20.26 20.26 0 00-1.69 3.132l-.219.538-.3-.5c-.05-.083-1.059-1.778-1.7-3.017a9.45 9.45 0 00-.25 3.66l.066.52-.474-.218a24.669 24.669 0 00-6.546-1.899c2.978 2.9 11.07 13.18 11.7 21.21.683 8.647.753 9.94.453 13.165-.118 1.248-1.612 3.518-3.68 6.662-3.575 5.423-8.464 12.85-9.894 20.425l-.112.6-.39-.464c-2.283-2.7-23.563-14.374-39.38-15.729a516.695 516.695 0 01-8.394-.8c-10.319-1.03-16.548-1.655-19.186 1.158l-1.634 1.744 1.171-2.084c1.158-2.06 1.8-3.242 2.144-3.875-1.432.525-4.672 1.937-5 4.061l.005-.03a3.447 3.447 0 00-1.27-2.96.583.583 0 00-.27-.153c-.64.591-4.685 4.378-5.49 6.59l-.364 1-.19-1.05a7.775 7.775 0 011.187-4.667c-1.94 1.617-5.364 4.791-5.364 7.1v2.776l-.57-2.715a13.17 13.17 0 01-.269-4.525c-1.724 2.56-5.04 7.738-5.04 9.667l-.577.01c-.116-3.1-.114-4.982-.084-6.087-1.037 2.18-2.932 6.725-2.285 9.632l-.562.135c-1.032-3.983-1.81-4.442-2.025-4.488a.185.185 0 00-.158.042c-.217.573-2.33 6.277-1.8 9.831.264.715.564 1.416.9 2.1l.912 1.823-1.382-1.5a4.221 4.221 0 01-.97-2.223c-.737-1.948-1.352-4.1-1.708-5.436-.556 3.28-1.783 11.846-.022 15.014l-.49.306a29.585 29.585 0 01-2.69-5.489c-.089 3.482-.118 12.344 1.688 16.641.463.622.955 1.318 1.478 2.09l.92 1.353-1.327-.958a5.084 5.084 0 01-1.53-2.139 13.78 13.78 0 00-3.039-3.33c.65 1.726 2.873 7.276 5.13 9 .146.094.3.192.447.292l-.3.494a3.693 3.693 0 01-.463-.299 22.155 22.155 0 00-5.25-2.458c.927 2.277 4.834 11.318 11.035 17.907 3.668 3.9 8.9 10.534 13.517 16.388 4.455 5.652 8.665 10.994 10.435 12.54 2.945 2.575 8.314.834 9.836.264-4.232-4.136-11.83-15.252-14.224-23.03-1.959-6.365-2.363-15.478.16-18.89a3.063 3.063 0 012.53-1.382c2.124 0 5.878 4.54 10.631 10.285 6.434 7.78 14.444 17.462 20.524 17.982 6.282.542 7.624-4.2 8.92-8.792.8-2.829 1.556-5.5 3.515-6.479 2.37-1.185 4.47 1.233 7.128 4.293 3.148 3.623 7.065 8.13 12.995 8.49 4.835.295 6.267-4.247 7.646-8.643 1.006-3.207 1.957-6.238 4.211-7.167 5.127-2.11 14.027-13.069 14.9-22.072.378-3.916-.329-10.738-1.01-17.337-1-9.675-1.95-18.81-.153-21.684.744-1.19 1.532-2.33 2.295-3.43 2.194-3.136 4.077-5.858 2.882-7.053"
          className="fill-svg-primary"
        />
        <g clipPath="url(#prefix__v)" opacity={0.35}>
          <path
            d="M640.37 373.95s.987-.58 3.79-.328c2.803.253 5.7 1.168 6.982 2.941a6.484 6.484 0 011.2 3.8l2.79-.406 2.213 2.4-7.68 2.85-6.167-2.037s-1.175-6.09-1.175-6.209c0-.119-1.954-3.012-1.954-3.012"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <path
          d="M733.082 329.874a103.961 103.961 0 007.36-10.524c3.69-5.93 4.3-13.652 4.4-15.544l.784.346c-.123 1.767-1.1 14.672-3.71 18.656l-.118.179c-2.699 4.129-6.041 9.221-9.368 10.944z"
          className="fill-svg-primary"
        />
        <path
          d="M744.935 309.394s9.648-3.888 10.1-12.482c-1.96 1.959-2.47 2.109-2.47 2.109s2.642-5.06 1.662-6.87a12.307 12.307 0 01-2.872 2.835s1.636-2.693-1.078-6.914a19.306 19.306 0 01-2.2 8.4s-1.24-1.272-1.618-5.342c-2.336 2.262-1.89 7.574-1.89 7.574s-.976.152-1.88-2.636c-1.961 5.73.61 12.074 1.66 13.155.176.11.378.17.586.17"
          className="fill-svg-primary-darker-2x"
        />
        <path
          d="M721.917 244.685s-13.908-8.028-15.15-11.984c-1.244-3.956 5.426-4.637 6.671-4.072 1.244.565 2.074-1.85 8.139-1.017 5.766.79 9.159 5.88 8.368 16.282-2.716-.791-8.028.79-8.028.79"
          className="fill-svg-primary"
        />
        <path
          d="M717.167 235.754s-4.069-3.167-3.729-7.125h.676s-1.242 1.696 3.053 7.125"
          className="fill-svg-primary"
        />
        <g clipPath="url(#prefix__w)" opacity={0.35}>
          <path
            d="M713.15 228.605c-.35 4.066 3.67 7.242 3.84 7.376l1.89 1.47-1.484-1.878c-4.037-5.1-3.19-6.884-3.19-6.884z"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <path
          d="M640.959 404.453c2.935 0 5.314-2.506 5.314-5.597 0-3.091-2.379-5.597-5.314-5.597s-5.314 2.506-5.314 5.597c0 3.09 2.379 5.597 5.314 5.597"
          fill="#fff"
        />
        <path
          d="M641.412 401.738a2.488 2.488 0 100-4.976 2.488 2.488 0 000 4.976"
          className="fill-svg-primary-darker-5x"
        />
        <path
          d="M641.487 401.06a.641.641 0 100-1.282.641.641 0 000 1.282"
          fill="#fff"
        />
        <path
          d="M621.751 362.675l.108-.318a.777.777 0 01.512-.451c1.023-.38 3.047.044 4.61.962 3.326 1.957 6.55 11.063 6.581 11.155l.073.206.218-.013a59.553 59.553 0 0112.814.674 5.425 5.425 0 014.746 6.01l-.048.376.376-.053a48.597 48.597 0 015.612-.448c1.861 0 3.534 4.256 4.02 5.9l.222.75.318-.715a21.235 21.235 0 001.234-4.041c.738 1.72.766 4.922.788 7.79.033 3.957.108 6.412 1.193 7.014 1.318.732 3.044-.031 5.041-.914a19.68 19.68 0 014.421-1.54c3.317-.586 9.514 1.452 10.886 1.926-.521 1.347-3.207 7.418-9.631 8.585-3.04.51-6.137.59-9.2.236-2.368-.2-4.077-.341-5.372.485-.332.21-.686.453-1.061.709-2.416 1.652-5.425 3.7-7.609 1.154l-.121-.138-.178.05a13.63 13.63 0 01-3.314.44c-1.6 0-3.806-4.035-4.8-8.813a5.316 5.316 0 00-2.3-3.55c-2-1.286-5.17-1.42-9.689-.407-3.824.862-7.791.822-10.354-.1a12.065 12.065 0 01-4.283-3.3l-.246-.3-.218.325a2.254 2.254 0 01-1.458.844 2.583 2.583 0 01-2.155-1.168c-.9-1.615-.453-4.35-.046-7.047l.031-.2-.176-.1a7.226 7.226 0 01-3.359-4.873c-.316-2.371 1.968-5.875 1.99-5.91l.07-.1-.031-.124a15.138 15.138 0 01.554-8.3 4.472 4.472 0 012.79-2.13 11.818 11.818 0 015.88-.694z"
          className="fill-svg-primary"
        />
        <path
          d="M652.361 404.113c3.383 0 6.125-2.809 6.125-6.275 0-3.465-2.742-6.275-6.125-6.275s-6.125 2.81-6.125 6.275c0 3.466 2.742 6.275 6.125 6.275"
          fill="#fff"
        />
        <path
          d="M652.727 401.07c1.403 0 2.54-1.249 2.54-2.789s-1.137-2.789-2.54-2.789-2.54 1.25-2.54 2.79 1.137 2.788 2.54 2.788"
          className="fill-svg-primary-darker-5x"
        />
        <g clipPath="url(#prefix__x)" opacity={0.35}>
          <path
            d="M619.786 384.607s-2.12-.338-2.177-3.39a3.991 3.991 0 011.131-2.377s-.96 4.071 1.046 5.767"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g clipPath="url(#prefix__y)" opacity={0.35}>
          <path
            d="M617.674 392.409s-.72-.112-.876-2.583c-.046-1.526.62-1.887.62-1.887s-.508 3.01.256 4.47"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g clipPath="url(#prefix__z)" opacity={0.35}>
          <path
            d="M621.731 362.67a3.56 3.56 0 012.388 1.399c.469.495.717 1.158.687 1.838a8.252 8.252 0 00-3.075-3.237"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g>
          <path
            d="M613.435 372.727s-.343-.066 1.73.292a5.249 5.249 0 013.013 1.724c1.162-.417 3.266-1.546 5.471-.663a11.568 11.568 0 015.5 6.007c.163.433-3.042-4.092-5.64-5.2-2.188-.934-4.905.072-5.06 1.217-.079.575-.764.608-.806-.255-.1-1.976-3.224-2.877-5.476-2.14-.618.2.268-.586 1.268-.982"
            className="fill-svg-primary-darker-3x"
          />
        </g>
        <g>
          <g clipPath="url(#prefix__A)" opacity={0.35}>
            <path
              d="M715.117 304.93c1.623 2.114 4.37 12.244 4.856 13.533.477-.216-.136-4.211-.988-6.87a19.889 19.889 0 00-2.4-5.275c-.79-1.168-2.138-2.255-1.468-1.387"
              className="fill-svg-primary-darker-2x"
            />
          </g>
        </g>
        <g>
          <path
            d="M623.207 385.119c.565 3.956 3.732 5.087 4.863 3.844 1.131-1.243.226-5.768-4.863-3.844"
            className="fill-svg-primary"
          />
        </g>
        <g>
          <g clipPath="url(#prefix__B)" opacity={0.35}>
            <path
              d="M623.654 385.375c1.081-.978 3.37-.314 4.086.654a2.4 2.4 0 01.114 2.739 1.514 1.514 0 01-1.6.286c-1.076-.328-3.514-2.851-2.599-3.678zm1.794-1.013c-.646 0-2.177.022-2.5.98-.45 1.316 1.86 3.872 3.136 4.265a2.074 2.074 0 002.2-.452 2.993 2.993 0 00-.064-3.451 3.193 3.193 0 00-2.772-1.342"
              className="fill-svg-primary-darker-2x"
            />
          </g>
        </g>
        <g>
          <path
            d="M666.624 400.495c2.26 1.357 8.931 4.07 13.454-.9-.902-1.701-11.303-1.473-13.454.9"
            className="fill-svg-primary-darker-2x"
          />
        </g>
        <g>
          <path
            d="M618.175 374.742a6.163 6.163 0 00-3.014-1.724 5.324 5.324 0 00-1.78.013 9.046 9.046 0 01-.35-1.709c-.34-4.86 1.64-7.349 5.54-7.462 4.013-.116 6.557 3.958 6.9 7.8.148 1.186.157 2.386.027 3.574a7.939 7.939 0 00-1.85-1.157c-2.207-.88-4.31.248-5.473.665"
            className="fill-svg-primary-darker-3x"
          />
        </g>
        <g>
          <path
            d="M623.998 370.08c1.131-1.923-1.641-5.658-5.652-5.54-3.9.111-4.222 2.337-3.279 3.468a2.168 2.168 0 003.354-.717c1.126 2.487 4.512 4.6 5.577 2.788"
            fill="#e15252"
          />
        </g>
        <g>
          <path
            d="M655.206 243.441s-15.6-6.67-16.847-10.629c-1.247-3.958 5.878-5.2 7.123-4.635 1.245.565 2.6-1.357 8.705-.9 6.105.457 12.326 4.523 11.534 14.925-2.713-.797-10.515 1.24-10.515 1.24"
            className="fill-svg-primary"
          />
        </g>
        <g>
          <path
            d="M645.747 307.515a108.266 108.266 0 012.94-17.187 215.124 215.124 0 017.763-22.917c-.995-2.233-1.658-8.214 1.643-9.345-.286-1.885.242-4.6.393-7.916.261-5.74-5.427-6.482-7.387-8.1a10.51 10.51 0 014.764.843 15.787 15.787 0 00-1.145-3.9 18.835 18.835 0 015.276 3.167s1.32-2.79 2.111-4.26c1.131 2.6 1.96 4.11 1.96 4.11l3.355-.265a10.313 10.313 0 00-3.264 5.655c-.587 3.455-.709 8.079-.995 10.44 1.245.1 2.412 8.29-.6 10.25.2 2.094-1.226 11.568.755 15.152 3.165 5.729 4.6 19.825 4.6 19.825"
            className="fill-svg-primary"
          />
        </g>
        <g>
          <path
            d="M649.212 235.3s-4.07-3.165-3.73-7.123h.677s-1.242 1.695 3.053 7.123"
            className="fill-svg-primary"
          />
        </g>
        <g>
          <g clipPath="url(#prefix__C)" opacity={0.35}>
            <path
              d="M645.194 228.15c-.349 4.068 3.67 7.244 3.842 7.376l1.891 1.47-1.487-1.878c-4.037-5.1-3.19-6.882-3.19-6.882z"
              className="fill-svg-primary-darker-2x"
            />
          </g>
        </g>
        <g>
          <path
            d="M652.003 399.967a.641.641 0 100-1.282.641.641 0 000 1.282"
            fill="#fff"
          />
        </g>
        <g>
          <g clipPath="url(#prefix__D)" opacity={0.35}>
            <path
              d="M730.128 240.88a8.487 8.487 0 00-1.616 1.46l-.3.366-.194-.428a6.574 6.574 0 01-.417-1.862 20.181 20.181 0 00-1.692 3.133l-.218.538-.3-.5c-.05-.083-1.06-1.777-1.7-3.017a9.433 9.433 0 00-.25 3.66l.067.519-.475-.217a29.763 29.763 0 00-3.09-1.15 68.714 68.714 0 00-1.928-1.095c1.643.358 3.25.866 4.8 1.52a7.856 7.856 0 01.61-4.052l.277-.485.236.5c.399.849 1.223 2.287 1.66 3.033a19.662 19.662 0 011.992-3.386l.485-.645.037.807c.02.678.115 1.35.282 2.007a8.225 8.225 0 011.737-1.406z"
              className="fill-svg-primary-darker-2x"
            />
          </g>
        </g>
        <g>
          <g clipPath="url(#prefix__E)" opacity={0.35}>
            <path
              d="M665.65 242.175l-1.75.136-.09-.161c-.009-.015-.73-1.335-1.73-3.584-.778 1.5-1.815 3.694-1.826 3.717l-.165.35-.288-.256a19.12 19.12 0 00-4.542-2.854c.41 1.075.707 2.189.89 3.325l.078.534-.488-.231a10.596 10.596 0 00-3.11-.79c-.4-.207-.81-.415-1.18-.6a11.108 11.108 0 014.037.662 14.859 14.859 0 00-1.03-3.301l-.307-.64.666.244a18.893 18.893 0 015.078 2.975c.376-.791 1.333-2.776 1.955-3.933l.283-.524.237.545a56.67 56.67 0 001.862 3.922l1.65-.131z"
              className="fill-svg-primary-darker-2x"
            />
          </g>
        </g>
        <g>
          <g clipPath="url(#prefix__F)" opacity={0.35}>
            <path
              d="M648.65 290.401a108.816 108.816 0 00-2.932 17.135l-.576-.044c-.403-3.493-.18-7.03.66-10.445.708-3.3 2.66-8.21 2.9-9.068.22-.099.517-.264.743-.356-.283.997-.535 1.785-.795 2.778M665.016 287.454c.231.075.433.07.66.152a33.542 33.542 0 012.334 7.151c.495 2.912.728 5.864.694 8.818l-.575.06c-.012-.116-1.01-9.698-3.113-16.18"
              className="fill-svg-primary-darker-2x"
            />
          </g>
        </g>
        <g>
          <path
            d="M623.655 385.375c1.081-.978 3.37-.314 4.086.654a2.4 2.4 0 01.114 2.74 1.514 1.514 0 01-1.6.285c-1.077-.328-3.515-2.855-2.6-3.679"
            className="fill-svg-primary-darker-3x"
          />
        </g>
      </g>
    </svg>
  );
};

export default NotFoundSVG;
